import React, { useState, useEffect } from "react";
import { Card, Row, Col, Typography } from "antd";
import axios from "axios";
import { CompanyLogo } from "@bindeleddet/core/components";
import { useViewport } from "@bindeleddet/core/hooks";
import { Company, Sector } from "@bindeleddet/core/types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBriefcase, faCompass, faLocationDot, faPeopleGroup } from "@fortawesome/free-solid-svg-icons";

const { Title, Text, Link } = Typography;

interface Props {
  company: Company;
}

const CompanyHeaderBox: React.FC<Props> = ({ company }) => {
  const { width } = useViewport();
  const breakpoint = 950;
  const [sectors, setSectors] = useState<string[]>([]);

  useEffect(() => {
    const fetchData = async () => {
      const promises = company.sectors.map((sector: number) =>
        axios.get<Sector>(`/companies/sectors/${sector}/`).then(response => {
          return response.data.name;
        })
      );
      const sectorNames = await Promise.all(promises);
      setSectors(sectorNames);
    };

    fetchData();
  }, [company]);

  const getSize = () => {
    if (company.size === 1) {
      return "1-10 ansatte";
    }
    if (company.size === 2) {
      return "11-50 ansatte";
    }
    if (company.size === 3) {
      return "51-200 ansatte";
    }
    if (company.size === 4) {
      return "201-500 ansatte";
    }
    if (company.size === 5) {
      return "501-1 000 ansatte";
    }
    if (company.size === 6) {
      return "1 001-5 000 ansatte";
    }
    if (company.size === 7) {
      return "5 001-10 000 ansatte";
    }
    if (company.size === 8) {
      return "10 001+ ansatte";
    }
    return "Antall ansatte ikke lagt inn";
  };

  return (
    <>
      <Card style={{ width: "100%", margin: "auto" }}>
        <Row gutter={10}>
          <Col span={width < breakpoint ? 24 : 4} style={{ minHeight: "50px" }}>
            <CompanyLogo
              size={width < breakpoint ? "100%" : "90%"}
              companyId={company.id}
              src={company.logo?.includes("http") ? company.logo : `${process.env.REACT_APP_API_URL}/${company.logo}`}
            />
          </Col>
          <Col
            span={width < breakpoint ? 24 : 10}
            style={width < breakpoint ? {} : { borderLeft: "1px solid grey", padding: "2px 15px" }}
          >
            <Row style={width < breakpoint ? { justifyContent: "center", marginTop: "15px" } : {}}>
              <Title
                level={width < breakpoint ? 3 : 2}
                style={{ margin: 0, fontWeight: "normal", marginBottom: "5px" }}
              >
                {company.name}
              </Title>
            </Row>
            <Row style={width < breakpoint ? { justifyContent: "center", marginBottom: "15px" } : {}}>
              <Text>
                <FontAwesomeIcon icon={faBriefcase} />
                {` ${sectors.join(", ")}`}
              </Text>
            </Row>
          </Col>
          <Col span={width < breakpoint ? 24 : 10}>
            <Row style={width < breakpoint ? { justifyContent: "center" } : { marginBottom: "7px" }}>
              <Text>
                <FontAwesomeIcon icon={faPeopleGroup} /> {getSize()}
              </Text>
            </Row>
            <Row style={width < breakpoint ? { justifyContent: "center" } : { marginBottom: "7px" }}>
              <Text>
                <FontAwesomeIcon icon={faLocationDot} />
                {` ${
                  company.visitor_region && company.visitor_region !== ""
                    ? company.visitor_region
                    : company.region && company.region !== ""
                    ? company.region
                    : company.country && company.country !== ""
                    ? company.country
                    : "Ikke lagt inn"
                }`}
              </Text>
            </Row>
            <Row style={width < breakpoint ? { justifyContent: "center" } : {}}>
              <Text>
                <Link
                  href={company.url?.includes("http") ? company.url : company.url ? `https://${company.url}` : "#"}
                  target="_blank"
                >
                  <FontAwesomeIcon icon={faCompass} /> {company.url ?? "Ikke lagt inn"}
                </Link>
              </Text>
            </Row>
          </Col>
        </Row>
      </Card>
    </>
  );
};

export default CompanyHeaderBox;
